import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  container: css`
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    border-radius: 12px;
    box-shadow: 0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    background: ${colors.white};
  `,
  illustration: css`
    width: 100%;
    height: ${pxToRem(168)};
    @media (min-width: 800px) {
      height: ${pxToRem(328)};
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    border-bottom: 1px solid ${colors.mercury};
  `,
  title: css`
    text-transform: capitalize;
    padding-bottom: 4px;
  `,
  content: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 17px;
    border-radius: 5px;
    min-height: ${pxToRem(84)};
  `,
};

export default styles;
